import { ElbowBlock } from "../models/resistances/ElbowBlock";
import { ConnectionPoint } from "../models/nets/ConnectionPoint";
import { Block } from "../models/shapes/Block";
import { Circle } from "../models/shapes/Circle";
import { Line } from "../models/shapes/Line";
import { Rectangle } from "../models/shapes/Rectangle";
import { Tee } from "../models/resistances/Tee";
import { Point } from "../models/Point";

export interface ICpoints {
  cp1: ConnectionPoint;
  cp2: ConnectionPoint;
}

export type Shape = (Line | Rectangle | Circle | Block | ElbowBlock | Tee);

export type NetElem = (Line | ElbowBlock | Tee);

export enum FlowDirection {
  IN = 'in',
  OUT = 'out',
  UNKNOWN = 'unknown'
}

export type RouteCrucialPoints = {
  start: Point,
  end: Point,
  mid?: Point,
  flowDirections?: {
    start: FlowDirection,
    end: FlowDirection,
    mid?: FlowDirection
  },
  isTerminal?: {
    start: boolean,
    end: boolean,
    mid?: boolean
  },
  pressure?: {
    start: number,
    end: number,
    mid?: number
  }
}

export enum MyEvents{
  updateCalculations = 'updateCalculations',
}

export interface SegWithConnectedSide{
  seg: Line;
  whichSideIsActive: 'start' | 'end'
}

export interface IDrawingMode{
  drawingMode: 'line' | 'networkSketch' | 'duct' | 'pipe'
}

export interface IObjectPropWindowCallType{
  show: boolean,
  calledWithShortcut: boolean
}

// Interface for network loop paths
export interface TerminalPath {
  path: string[]; // Array of node IDs forming the path
}
